import React, { useEffect } from "react";
import ReportModalComponent from '../../components/ReportModal';
import { useDispatch, useSelector } from "react-redux";
import * as reportActions from "../../redux/actions/reportAction";
import { bindActionCreators } from "redux";
import { PREFERED_LANGUAGE_KEYS } from "../../App.config";

const ReportModalContainer = (props, context) => {
  const profileReducer = useSelector((state) => state.profileReducer);
  const in18State = useSelector((state) => state.i18nState);
  const dispatch = useDispatch();
  const reportAction = bindActionCreators(reportActions, dispatch);
  const onDownloadReportClick = (downloadFormat, fromDate, toDate, moduleId, reportId, levelNo, levelItemId, reportName) =>
    reportAction.onDownloadReportClick(profileReducer.managersDetails.companyId, downloadFormat, fromDate, toDate,
      moduleId, reportId, levelNo, levelItemId, reportName, in18State.lang === PREFERED_LANGUAGE_KEYS.EnglishUS);

  return (
    <ReportModalComponent onDownloadReportClick={onDownloadReportClick} {...props} />
  );
};


export default ReportModalContainer;
